import { AppState } from 'state/state.model';

export const selectQuoteDetails = (state: AppState, quoteId: string) => state.quotes?.details?.[quoteId];
